import { SvgIconProps } from '@mui/material'
import { AutoAwesome, Cancel, CheckCircle, FiberManualRecord, RadioButtonUncheckedOutlined } from '@mui/icons-material'

import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'

export interface AnswerStatusIconProps extends SvgIconProps {
  answerStatus: FormAnswerStatus
}

const AnswerStatusIcon: React.FC<AnswerStatusIconProps> = ({ answerStatus: status, ...rest }) => {
  switch (status) {
    case FormAnswerStatus.Pending:
      return <FiberManualRecord {...rest} />
    case FormAnswerStatus.Pass:
    case FormAnswerStatus.ApprovedByReviewer:
      return <CheckCircle {...rest} />
    case FormAnswerStatus.Fail:
    case FormAnswerStatus.RejectedByReviewer:
      return <Cancel {...rest} />
    case FormAnswerStatus.ApprovedByAI:
    case FormAnswerStatus.RejectedByAI:
      return <AutoAwesome {...rest} />
    default:
      return <RadioButtonUncheckedOutlined {...rest} />
  }
}

export default AnswerStatusIcon
